import { Badge, Card, Col, Row } from "react-bootstrap";
import { cpkBadgeVariant, fmtNum } from "../../Services/processo/dashboardProcessoUtils";
import EstatisticasFrequenciaDashboard from "./EstatisticasFrequenciaDashboard";

/* ============================================================================
 * Header global — somente KPIs estatísticos
 * ==========================================================================*/
function GlobalResumoCard({ estatisticasGlobais = {}, estatisticasDeFrequencia = {}}) {
  const totalControles = estatisticasGlobais?.totalControles ?? 0;
  const cpkMedio = estatisticasGlobais?.cpkMedio ?? null;
  
  // KPIs atualizados
  const itensAlertaEstatistica = estatisticasGlobais?.itensAlertaEstatistica ?? 0;
  const totalRegistrosFora = estatisticasGlobais?.totalRegistrosForaGlobal ?? 0;
  const totalRegistros = estatisticasGlobais?.totalRegistrosGlobal ?? 0;
  const pctFora = estatisticasGlobais?.totalRegistrosForaPct ?? 0;

  return (
    <Card className="mb-3 mt-3">
      <Card.Body>
        <Row className="g-3 align-items-center">
          <Col md={4} sm={6}>
            <div className="text-muted small">Cpk Global (médio)</div>
            <h4 className="mb-1">
              <Badge bg={cpkBadgeVariant(cpkMedio)}>
                {fmtNum(cpkMedio, 3)}
              </Badge>
            </h4>
            <div className="small text-muted">
              Controles analisados: {totalControles}
            </div>
          </Col>
          <Col md={4} sm={6}>
            <div className="text-muted small">Desvios & Alertas</div>
            <h4 className="mb-1 d-flex gap-2 align-items-center">
              <Badge bg={totalRegistrosFora > 0 ? "danger" : "success"} title="Total de registros fora de especificação">
                 {totalRegistrosFora} Reg.
              </Badge>
              {itensAlertaEstatistica > 0 && (
                  <Badge bg="warning" text="dark" style={{fontSize: '0.6em'}} title="Controles com alertas estatísticos">
                    {itensAlertaEstatistica} Ctrs.
                  </Badge>
              )}
            </h4>
            <div className="small text-muted">
              {fmtNum(pctFora, 2)}% fora ({totalRegistrosFora}/{totalRegistros})
            </div>
          </Col>
          <Col md={4} sm={12}>
            <EstatisticasFrequenciaDashboard
              estatisticas={estatisticasDeFrequencia}
            />
          </Col>
        </Row>

      </Card.Body>
    </Card>
  );
}

export default GlobalResumoCard;